import React, { useEffect, useRef } from 'react'

import { Route, Switch, useHistory } from 'react-router-dom'
import EditPage from 'routes/Edit'
import HomePage from 'routes/Home'
import NoCalendarPage from 'routes/NoCalendar'

import { Box, Flex, styled } from '@driftt/dds'
import { DriftAnalytics } from '@driftt/dds.analytics'
import { RoutingProblemsBanner } from '@driftt/meeting-components'

import useCalendarStatus from 'hooks/useCalendarStatus'
import useCurrentUser from 'hooks/useCurrentUser'
import useIsAdmin from 'hooks/useIsAdmin'

import './styles.css'

const PageTitle = styled(Flex, {
  height: 80,
  width: '100%',
  paddingLeft: '$4',
  paddingRight: '$4',
  borderBottom: '1px solid $gray3',
  background: '$white',
})

const RouteContainer = styled(Box, {
  width: '100%',
  height: 'calc(100% - 80px)',
  overflow: 'auto',
  backgroundColor: '$gray2',
  paddingBottom: '$8',
})

const Page = styled(Box, {
  maxWidth: 1024,
  margin: '$4 auto',
})

const Routes = {
  edit: {
    path: ['/edit/:id', '/new'],
    Component: EditPage,
  },
  noCal: { path: '/get-started', Component: NoCalendarPage },
  home: {
    path: '/',
    Component: HomePage,
  },
}

const AppLayout = () => {
  const history = useHistory()
  const isAdmin = useIsAdmin()

  const currentUser = useCurrentUser()

  const routeContainerRef = useRef<HTMLDivElement>(null)

  const { data } = useCalendarStatus()

  useEffect(() => {
    currentUser && DriftAnalytics.initialize({ user: currentUser })
  }, [currentUser])

  useEffect(() => {
    if (!data) {
      return
    }

    if (data.connected || isAdmin) {
      return
    }

    history.replace('/get-started')
  }, [history, data, isAdmin])

  useEffect(() => {
    return history.listen(() => {
      routeContainerRef.current?.scrollTo(0, 0)
    })
  }, [history])

  if (!data) {
    return null
  }

  return (
    <>
      {isAdmin && <RoutingProblemsBanner />}
      <PageTitle alignItems="center">
        <Switch>
          {Object.entries(Routes).map(([key, { path, Component }]) => (
            <Route path={path} key={key}>
              <Component.Header />
            </Route>
          ))}
        </Switch>
      </PageTitle>
      <RouteContainer ref={routeContainerRef}>
        <Page>
          <Switch>
            {Object.entries(Routes).map(([key, { path, Component }]) => (
              <Route path={path} key={key}>
                <Component />
              </Route>
            ))}
          </Switch>
        </Page>
      </RouteContainer>
    </>
  )
}

export default AppLayout
